
import { SuburbLookupData } from '@/models/main';
import { AddressBookData } from '@/models/addressBook';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class LookupSuburb extends Vue {
  @Prop({ type: Number, required: true }) private readonly stop!: number;
  @Prop({ type: Number, required: false }) public readonly shift_id!: number;
  @Prop({ type: Number, required: false }) private readonly editedItem!: number;
  @Prop({ type: Boolean, required: true }) public readonly disabled!: boolean;
  @Prop({ type: Object, required: false }) private readonly chosen!: AddressBookData;
  @Prop({ type: Number, required: false }) public readonly tabIndex!: number;
  @Prop({ type: Function, required: true }) private autocomplete!: (params: string) => Promise<SuburbLookupData[]>;

  public loading = false;
  public inputText = '';
  public itemSearch: SuburbLookupData[] = [];
  private selectedSuburbDefault = {
    id: -1,
    name: '',
    postcode: '',
    state: '',
    zone: '',
  };
  public selectedSuburb = { ...this.selectedSuburbDefault };

  public clear() {
    this.selectedSuburb = { ...this.selectedSuburbDefault };
    this.inputText = '';
    this.$emit('clear', this.shift_id ? this.shift_id : this.stop);
  }

  public search(val) {
    this.inputText = val;
    if (!val) {
      return;
    }
    const chosenString = this.selectedSuburb.name.slice(0, val.length);
    if (val?.length >= 3) {
      this.itemSearch = [];
      this.loading = true;
      this.autocomplete(val)
        .then(data => {
          this.itemSearch = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    } else if (this.selectedSuburb.id >= 0 && val !== chosenString) {
      this.clear();
      this.selectedSuburb.name = val;
      return val;
    }
  }

  public change() {
    if (!this.selectedSuburb) {
      this.itemSearch = [];
      this.selectedSuburb = this.selectedSuburbDefault;
      this.$emit('clear', this.shift_id ? this.shift_id : this.stop);
    } else {
      this.$emit('change', this.shift_id ? this.shift_id : this.stop, this.selectedSuburb);
    }
  }

  @Watch('chosen', { immediate: true, deep: true })
  private watchToChosen() {
    // Clear the suburb if the parent has been cleared
    if (this.chosen.suburbId === -1) {
      this.selectedSuburb = { ...this.selectedSuburbDefault };
      return;
    }
    if (
      this.chosen.suburb &&
      typeof this.chosen.suburb === 'string' &&
      this.selectedSuburb &&
      (this.chosen.suburbId !== this.selectedSuburb.id || this.chosen.suburbId === -1)
    ) {
      this.loading = true;
      this.autocomplete(this.chosen.suburb)
        .then(data => {
          this.itemSearch = data;
          const find = data.find(x => x.id === this.chosen.suburbId || x.state === this.chosen.state);
          if (find) {
            this.selectedSuburb = find;
            // maybe better to add 'suburb_id' to the backend ?
            this.$emit('change', this.stop, this.selectedSuburb);
          }
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    } else if (this.itemSearch.length >= 1 && this.editedItem === -1 && this.chosen.suburbId === -1) {
      this.itemSearch = [];
    }
  }
}
